export const GOOGLE_MAPS_API_KEY = process.env.GOOGLE_MAPS_API_KEY;
